/**
 * Reports API endpoints
 */
import type {
    ApiResponse,
    ApiListResponse,
    Report,
    ReportInput,
    ReportUpdate,
    ReportPreviewRequest,
    ReportQueryResult,
    ReportExecuteRequest,
} from "../lib/types";
import { authenticatedRequest } from "../lib/api";

export async function getReports(token: string): Promise<Report[]> {
    return authenticatedRequest<ApiListResponse<Report>>(
        "/api/reports",
        token
    ).then((res) => res.data);
}

export async function getReport(token: string, id: string): Promise<Report> {
    return authenticatedRequest<ApiResponse<Report>>(
        `/api/reports/${id}`,
        token
    ).then((res) => res.data);
}

export async function createReport(
    token: string,
    input: ReportInput
): Promise<Report> {
    return authenticatedRequest<ApiResponse<Report>>("/api/reports", token, {
        method: "POST",
        body: JSON.stringify(input),
    }).then((res) => res.data);
}

export async function updateReport(
    token: string,
    id: string,
    input: ReportUpdate
): Promise<Report> {
    return authenticatedRequest<ApiResponse<Report>>(`/api/reports/${id}`, token, {
        method: "PUT",
        body: JSON.stringify(input),
    }).then((res) => res.data);
}

export async function deleteReport(token: string, id: string): Promise<void> {
    return authenticatedRequest<void>(`/api/reports/${id}`, token, {
        method: "DELETE",
    });
}

export async function previewReport(
    token: string,
    request: ReportPreviewRequest
): Promise<ReportQueryResult> {
    return authenticatedRequest<ApiResponse<ReportQueryResult>>(
        "/api/reports/preview",
        token,
        {
            method: "POST",
            body: JSON.stringify(request),
        }
    ).then((res) => res.data);
}

export async function executeReport(
    token: string,
    id: string,
    request?: ReportExecuteRequest
): Promise<ReportQueryResult> {
    return authenticatedRequest<ApiResponse<ReportQueryResult>>(
        `/api/reports/${id}/execute`,
        token,
        {
            method: "POST",
            body: JSON.stringify(request || {}),
        }
    ).then((res) => res.data);
}

export async function executeVariableQuery(
    token: string,
    request: ReportPreviewRequest
): Promise<ReportQueryResult> {
    return authenticatedRequest<ApiResponse<ReportQueryResult>>(
        "/api/reports/variable-query",
        token,
        {
            method: "POST",
            body: JSON.stringify(request),
        }
    ).then((res) => res.data);
}
